<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-md-8 mx-auto">
                <div class="card">
                    <div class="card-header pb-0">
                        <div class="d-flex align-items-center">
                            <p class="mb-0">Crear Categoría de Producto</p>
                        </div>
                    </div>
                    <div class="card-body">
                        <form @submit.prevent="submitCategory">
                            <div class="row">
                                <div class="col-md-6">
                                    <label class="form-control-label">Nombre de la Categoría</label>
                                    <argon-input v-model="category.name" type="text" placeholder="Ej: Electrónicos, Bebidas" />
                                    <small v-if="submitted && v$.category.name.$error" class="text-danger">Nombre de la categoría requerido.</small>
                                </div>
                                <div class="col-md-6">
                                    <label class="form-control-label">Estado</label>
                                    <select class="form-control" v-model="category.state">
                                        <option value="1">Activo</option>
                                        <option value="2">Inactivo</option>
                                    </select>
                                    <small v-if="submitted && v$.category.state.$error" class="text-danger">Estado requerido.</small>
                                </div>
                                </div>
                            <argon-button
                                type="submit"
                                class="mt-4"
                                color="success"
                                fullWidth
                                size="lg"
                            >
                                Guardar Categoría
                            </argon-button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import { useVuelidate } from '@vuelidate/core';
import { required, helpers } from '@vuelidate/validators';
import axios from "axios";
import Swal from 'sweetalert2';

export default {
    name: "CreateCategory", // 🛑 Nombre del componente actualizado
    components: { ArgonInput, ArgonButton },
    setup: () => ({ v$: useVuelidate() }),
    data() {
        const companyId = parseInt(localStorage.getItem('companyId'));

        return {
            submitted: false,
            category: { // 🛑 Objeto de datos renombrado a 'category'
                name: '',
                state: 1, // 🛑 Usando ACTIVE/INACTIVE como default
                company: companyId || null // Mapea a 'company_id' en la BD
            }
        };
    },
    validations() {
        return {
            category: { // 🛑 Validaciones para 'category'
                name: { required: helpers.withMessage('El nombre es requerido', required) },
                state: { required: helpers.withMessage('El estado es requerido', required) },
                company: { required: helpers.withMessage('ID de compañía faltante (Reinicie sesión)', required) }
            }
        };
    },
    methods: {
        submitCategory() { // 🛑 Nombre del método actualizado
            this.submitted = true;
            this.v$.$touch();

            if (this.v$.$invalid) {
                Swal.fire({
                    title: 'Datos inválidos',
                    text: 'Por favor, revisa los campos requeridos.',
                    icon: 'warning',
                    confirmButtonColor: '#0b9257'
                });
                return;
            }

            const token = localStorage.getItem("accessToken");
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'accept': '*/*',
                    'Authorization': `Bearer ${token}`
                }
            };

            // El payload se llama 'category' y mapea a la tabla 'products_category'
            const payload = {
                name: this.category.name,
                state: this.category.state,
                company: this.category.company // 🛑 Asegura que el nombre de la columna sea correcto para la BD
            };

            // 🛑 Endpoint actualizado a 'products_category' 🛑
            axios.post(this.$store.state.apiURL + 'products_category', payload, config)
                .then(() => {
                    Swal.fire({
                        title: 'Categoría Creada',
                        text: 'La categoría fue registrada correctamente.',
                        icon: 'success',
                        confirmButtonColor: '#0b9257'
                    }).then(() => {
                        // 🛑 Redirección a la vista de categorías 🛑
                        this.$router.push('/settings/categories');
                    });
                })
                .catch((err) => {
                    console.error("Error al crear categoría:", err.response || err);
                    let errorText = 'No se pudo guardar la categoría.';

                    if (err.response && err.response.data && err.response.data.error && err.response.data.error.includes('Duplicate entry')) {
                         errorText = 'El nombre de la categoría ya existe en tu compañía.';
                    } else if (err.response && err.response.data && err.response.data.error) {
                         errorText = err.response.data.error;
                    }

                    Swal.fire({
                        title: 'Error',
                        text: errorText,
                        icon: 'error',
                        confirmButtonColor: '#0b9257'
                    });
                });
        }
    }
};
</script>